import { createAction } from '@reduxjs/toolkit'

export const getAutoEnrollRules = createAction('autoEnroll/getAutoEnrollRules')

export const saveAutoEnrollRules = createAction(
  'autoEnroll/saveAutoEnrollRules'
)
